const DOTO_DOTOCASH_ICON_DATA_URI = 'data:image/png;base64,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';

const DOTO_RECENTLY_VIEWED_KEY = 'doto_recently_viewed_products_v1';

function getRecentlyViewedHandles() {
  try {
    const history = JSON.parse(localStorage.getItem(DOTO_RECENTLY_VIEWED_KEY) || '[]');
    return Array.isArray(history)
      ? history.filter((handle) => typeof handle === 'string' && handle.trim() !== '')
      : [];
  } catch (error) {
    return [];
  }
}

function moneyFormatter() {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return {
    format(value) {
      const amount = Number(value || 0);
      return `$ ${numberFormatter.format(Number.isFinite(amount) ? amount : 0)}`;
    }
  };
}

function imageWithWidth(url, width = 520) {
  if (!url) return '';
  return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
}

function makeTextElement(tag, className, text) {
  const element = document.createElement(tag);
  element.className = className;
  element.textContent = text;
  return element;
}

function createDotoCashbackFromPesos(pricePesos, iconUrl = '') {
  const amount = Math.round(Number(pricePesos || 0) * 0.01);
  if (!Number.isFinite(amount) || amount <= 0) return null;

  const badge = document.createElement('span');
  badge.className = 'doto-card-cashback';
  badge.dataset.dotoCardCashback = 'true';
  badge.dataset.dotoCashbackPercent = '1';
  badge.title = 'Recibe 1% en DotoCash';
  badge.setAttribute('aria-label', `Recibe $${amount.toLocaleString('en-US')} en DotoCash`);

  const icon = document.createElement('img');
  icon.className = 'doto-card-cashback__icon';
  icon.src = iconUrl || DOTO_DOTOCASH_ICON_DATA_URI;
  icon.alt = '';
  icon.width = 20;
  icon.height = 20;
  icon.loading = 'lazy';
  icon.setAttribute('aria-hidden', 'true');

  const value = document.createElement('span');
  value.className = 'doto-card-cashback__amount';
  value.textContent = `$${amount.toLocaleString('en-US')}`;

  const label = document.createElement('span');
  label.className = 'doto-card-cashback__label';
  label.textContent = 'en dotocash';

  badge.append(icon, value, label);
  return badge;
}

function getCheapestVariant(product) {
  const variants = Array.isArray(product?.variants) ? product.variants : [];
  if (!variants.length) return null;

  const available = variants.filter((variant) => variant?.available);
  const candidates = available.length ? available : variants;

  return candidates.reduce((cheapest, variant) => {
    if (!cheapest) return variant;
    return Number(variant?.price || Infinity) < Number(cheapest?.price || Infinity)
      ? variant
      : cheapest;
  }, null);
}

function getVariantImage(variant, product) {
  const featured = variant?.featured_image;
  if (typeof featured === 'string') return featured;
  if (featured?.src) return featured.src;
  return product?.featured_image || '';
}

function getVariantUrl(product, variant, config) {
  const baseUrl = product?.url || `${config.rootUrl}products/${product?.handle || ''}`;
  if (!variant?.id) return baseUrl;
  return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}variant=${variant.id}`;
}

function createQuickAdd(product, config) {
  const variant = getCheapestVariant(product);

  const quickAdd = document.createElement('doto-carousel-quick-add');
  quickAdd.className = `doto-carousel-quick-add${!variant?.available ? ' !disabled' : ''}`;
  quickAdd.dataset.productTitle = product.title || '';
  if (variant?.id) quickAdd.dataset.variantId = String(variant.id);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'doto-carousel-quick-add__button';
  button.title = variant?.available ? 'Agregar al carrito' : 'Agotado';
  button.setAttribute(
    'aria-label',
    variant?.available
      ? `Agregar ${product.title || 'producto'} al carrito`
      : `${product.title || 'Producto'} agotado`
  );

  button.innerHTML = `
    <span class="doto-carousel-quick-add__plus" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none">
        <path d="M2.75 3.5h2.1l1.42 7.55a1.55 1.55 0 0 0 1.53 1.27h5.67a1.55 1.55 0 0 0 1.5-1.18L16.2 6H5.35" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="8.15" cy="15.65" r="1.1" fill="currentColor"/>
        <circle cx="14.1" cy="15.65" r="1.1" fill="currentColor"/>
      </svg>
    </span>
    <span class="doto-carousel-quick-add__check" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none">
        <path d="m5 10.3 3.1 3.1L15 6.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  `;

  if (!variant?.available) {
    button.disabled = true;
    quickAdd.appendChild(button);
    return quickAdd;
  }

  button.setAttribute('data-doto-carousel-quick-add-button', '');
  quickAdd.appendChild(button);

  return quickAdd;
}

function createProductCard(product, config) {
  const article = document.createElement('article');
  article.className = 'doto-recently-viewed__card';
  article.setAttribute('data-doto-quick-add-card', '');

  const cheapestVariant = getCheapestVariant(product);
  const variantImage = getVariantImage(cheapestVariant, product);

  const link = document.createElement('a');
  link.className = 'doto-recently-viewed__link';
  link.href = getVariantUrl(product, cheapestVariant, config);
  link.setAttribute('aria-label', product.title || 'Ver producto');

  const media = document.createElement('div');
  media.className = 'doto-recently-viewed__media';

  if (variantImage) {
    const image = document.createElement('img');
    image.className = 'doto-recently-viewed__image';
    image.src = imageWithWidth(variantImage, 520);
    image.alt = product.title || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    media.appendChild(image);
  }

  const badge = makeTextElement('span', 'doto-recently-viewed__badge', 'Visto recientemente');
  media.appendChild(badge);

  const content = document.createElement('div');
  content.className = 'doto-recently-viewed__content';

  if (config.showVendor && product.vendor) {
    content.appendChild(makeTextElement('div', 'doto-recently-viewed__vendor', product.vendor));
  }

  content.appendChild(makeTextElement('h3', 'doto-recently-viewed__product-title', product.title || ''));

  const priceRow = document.createElement('div');
  priceRow.className = 'doto-recently-viewed__price-row';

  const formatter = moneyFormatter(config.currency, config.locale);
  const priceValue = Number(cheapestVariant?.price || product.price || 0) / 100;
  const compareValue = Number(cheapestVariant?.compare_at_price || 0) / 100;
  const priceText = formatter.format(priceValue);

  priceRow.appendChild(makeTextElement('span', 'doto-recently-viewed__price', priceText));

  if (config.showComparePrice && compareValue > priceValue) {
    priceRow.appendChild(
      makeTextElement('span', 'doto-recently-viewed__compare-price', formatter.format(compareValue))
    );
  }

  content.appendChild(priceRow);

  const cashback = createDotoCashbackFromPesos(priceValue, config.dotocashIcon);
  if (cashback) content.appendChild(cashback);

  if (!product.available) {
    content.appendChild(makeTextElement('span', 'doto-recently-viewed__sold-out', 'Agotado'));
  }

  link.appendChild(media);
  link.appendChild(content);
  article.appendChild(link);
  article.appendChild(createQuickAdd(product, config));

  return article;
}

async function fetchProduct(handle, rootUrl) {
  const root = (rootUrl || '/').replace(/\/$/, '');
  const response = await fetch(`${root}/products/${encodeURIComponent(handle)}.js`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  });

  if (!response.ok) {
    throw new Error(`Product fetch failed: ${response.status}`);
  }

  return response.json();
}

function syncArrows(section) {
  const track = section.querySelector('[data-rv-track]');
  const prev = section.querySelector('[data-rv-prev]');
  const next = section.querySelector('[data-rv-next]');

  if (!track || !prev || !next) return;

  const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft >= maxScroll - 4 || maxScroll <= 4;
}

function bindArrows(section) {
  const track = section.querySelector('[data-rv-track]');
  const prev = section.querySelector('[data-rv-prev]');
  const next = section.querySelector('[data-rv-next]');

  if (!track || !prev || !next || section.dataset.rvArrowsBound === 'true') return;

  section.dataset.rvArrowsBound = 'true';

  const scrollAmount = () => {
    const firstCard = track.querySelector('.doto-recently-viewed__card');
    if (!firstCard) return track.clientWidth * 0.8;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');
    return firstCard.getBoundingClientRect().width + gap;
  };

  prev.addEventListener('click', () => {
    track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  next.addEventListener('click', () => {
    track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => syncArrows(section));
  }, { passive: true });

  window.addEventListener('resize', () => syncArrows(section), { passive: true });
}

function keepEditorPreview(section) {
  if (section.dataset.editorPreview !== 'true') return false;
  section.hidden = false;
  bindArrows(section);
  window.requestAnimationFrame(() => syncArrows(section));
  return true;
}

async function initRecentlyViewed(section) {
  if (!section || section.dataset.rvReady === 'true') return;
  section.dataset.rvReady = 'true';

  const track = section.querySelector('[data-rv-track]');
  if (!track) return;

  const limit = Number(section.dataset.limit || 8);
  const currentHandle = section.dataset.currentHandle || '';
  const rootUrl = section.dataset.rootUrl || '/';

  const config = {
    rootUrl,
    sectionId: section.dataset.sectionId || '',
    currency: section.dataset.currency || 'MXN',
    locale: section.dataset.locale || 'es-MX',
    hideSoldOut: section.dataset.hideSoldOut === 'true',
    showVendor: section.dataset.showVendor === 'true',
    showComparePrice: section.dataset.showComparePrice === 'true',
    dotocashIcon: section.dataset.dotocashIcon || DOTO_DOTOCASH_ICON_DATA_URI
  };

  const handles = [...new Set(getRecentlyViewedHandles())]
    .filter((handle) => handle !== currentHandle)
    .slice(0, Math.max(limit * 2, limit));

  if (handles.length === 0) {
    keepEditorPreview(section);
    return;
  }

  const results = await Promise.allSettled(
    handles.map((handle) => fetchProduct(handle, rootUrl))
  );

  const products = results
    .filter((result) => result.status === 'fulfilled')
    .map((result) => result.value)
    .filter((product) => !config.hideSoldOut || product.available)
    .slice(0, limit);

  if (products.length === 0) {
    keepEditorPreview(section);
    return;
  }

  const fragment = document.createDocumentFragment();
  products.forEach((product) => {
    fragment.appendChild(createProductCard(product, config));
  });

  track.replaceChildren(fragment);
  section.hidden = false;

  bindArrows(section);
  window.requestAnimationFrame(() => syncArrows(section));
}

function initAllRecentlyViewed(root = document) {
  root.querySelectorAll?.('[data-doto-recently-viewed]').forEach((section) => {
    initRecentlyViewed(section).catch(() => {
      if (!keepEditorPreview(section)) {
        section.hidden = true;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllRecentlyViewed());
} else {
  initAllRecentlyViewed();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllRecentlyViewed(event.target);
});
